import { render, staticRenderFns } from "./editLeaveTransactionPropertyGroup.vue?vue&type=template&id=35ee24b2&"
import script from "./editLeaveTransactionPropertyGroup.vue?vue&type=script&lang=js&"
export * from "./editLeaveTransactionPropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VRow,VSheet,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ee24b2')) {
      api.createRecord('35ee24b2', component.options)
    } else {
      api.reload('35ee24b2', component.options)
    }
    module.hot.accept("./editLeaveTransactionPropertyGroup.vue?vue&type=template&id=35ee24b2&", function () {
      api.rerender('35ee24b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Leave/LeaveTransactionPropertyGroup/editLeaveTransactionPropertyGroup.vue"
export default component.exports